import React from 'react';
import { BadgesSection, BonusesSection } from './catalog-section';
import { EditionSection } from './edition-section';
import { RulesSection } from './rules-section';
import { SectionSave, SetupFormPane, useSetupForm } from './setup-form';

export { Doc31SetupFormProvider } from './setup-form';
export type {
    Doc31SetupFormProviderProps,
    Doc31SetupTabKey,
} from './setup-form';

/** Dates, rules version and game rules, with the go-live check. */
export const Doc31SetupTab: React.FC = () => {
    const { form, onPlayWindowChange, onMaxPlayDaysChange } = useSetupForm();
    return (
        <SetupFormPane>
            <EditionSection
                form={form}
                onPlayWindowChange={onPlayWindowChange}
                saveAction={<SectionSave section="edition" />}
            />
            <RulesSection
                form={form}
                onMaxPlayDaysChange={onMaxPlayDaysChange}
                saveAction={<SectionSave section="rules" />}
            />
        </SetupFormPane>
    );
};

/** Bonus actions and badges, with the go-live check. */
export const Doc31CatalogTab: React.FC = () => {
    const { form, expanded, toggleExpanded } = useSetupForm();
    return (
        <SetupFormPane>
            <BonusesSection
                form={form}
                expandedKeys={expanded.bonuses}
                onToggleExpanded={toggleExpanded}
                saveAction={<SectionSave section="bonuses" />}
            />
            <BadgesSection
                form={form}
                expandedKeys={expanded.badges}
                onToggleExpanded={toggleExpanded}
                saveAction={<SectionSave section="badges" />}
            />
        </SetupFormPane>
    );
};
